import { useState } from "react";
import TextInput from "../../Components/TextInput";
import Button from "../../Components/Button";
import {
  addInstrument,
  deleteInstrument,
} from "../../Requests/insSettingRequests";
import { toast } from "react-toastify";
import Loading from "../../Components/Loading/Loading";

const AddDeleteInstrumentForm = () => {
  const [url, setUrl] = useState<string | null>(null);

  const [loading, setLoading] = useState(false);

  const addInsClickHandler = () => {
    if (!url) return;
    setLoading(true);
    addInstrument(url)
      .then((resp) => toast.success(resp.msg))
      .catch((e) => toast.error(e.response.data.value))
      .finally(() => setLoading(false));
  };

  const deleteInsClickHandler = () => {
    if (!url) return;
    setLoading(true);
    deleteInstrument(url)
      .then((resp) => toast.success(resp.msg))
      .catch((e) => toast.error(e.response.data.value))
      .finally(() => setLoading(false));
  };

  return (
    <div className="border-2 border-gray-300 flex flex-col justify-start items-center gap-3 w-80 p-2 rounded-md">
      <h2>اضافه کردن نماد</h2>
      <TextInput
        label="آدرس نماد در tsetmc"
        name="url"
        onChange={(_, value) => setUrl(value)}
        value={url || ""}
      />

      <Button
        text={
          loading ? <Loading size={20} className="!text-white" /> : "اضافه کردن"
        }
        variant="contained"
        onClick={addInsClickHandler}
        disabled={!!!url}
      />
      <Button
        text={loading ? <Loading size={20} className="!text-white" /> : "حذف"}
        variant="contained"
        onClick={deleteInsClickHandler}
        className={url ? "red-btn" : ""}
        disabled={!url}
      />
    </div>
  );
};

export default AddDeleteInstrumentForm;
